import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ReactSwitch from 'react-switch';

const Toggle = ({
  checked,
  disabled,
  className,
  onChange,
  labelOn,
  labelOff,
  height = 16,
  width = 32,
  handleDiameter = 10,
}) => (
  <div className={classnames('Toggle__container', className)}>
    <span>{labelOff}</span>
    <ReactSwitch
      height={height}
      width={width}
      handleDiameter={handleDiameter}
      checkedIcon={null}
      uncheckedIcon={null}
      onColor="#007bff"
      offColor="#007bff"

      onChange={onChange}
      checked={checked}
      disabled={disabled}
    />
    <span>{labelOn}</span>
  </div>
);

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  labelOn: PropTypes.string,
  labelOff: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  handleDiameter: PropTypes.number,
  className: PropTypes.string,
};

export default Toggle;
